






















import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  props: {
    mediaId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formError: null,
      isDeleting: false,
    };
  },
  methods: {
    async deleteLibraryMedia() {
      try {
        this.isDeleting = true;
        const dispatchPromise = await this.$store.dispatch(
          'mediaLibrary/deleteMedia',
          this.mediaId
        );
        this.$router.push({ name: 'media-library' });
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('MEDIA_LIBRARY.NOTIFICATIONS.MEDIA_REMOVE_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('MEDIA_LIBRARY.NOTIFICATIONS.MEDIA_REMOVE_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
});
